module.exports = __webpack_public_path__ + "media/images/profile-02-p-500-c6c4ccb568984765412fff1eb9d29d15.png";